import { v4 as uuidv4 } from 'uuid';

import { SessionStorageAdapter } from '@/lib/adapters/session-storage';

const adapter = new SessionStorageAdapter('session');

export const getSessionId = (): string => {
  // Do not memory cache this value, if an user cleans the browser cache
  // it should change as well as if a new session was created.
  let sessionId = adapter.getItem<string>('sessionId');

  if (!sessionId) {
    sessionId = uuidv4();
    adapter.setItem('sessionId', sessionId);
  }

  return sessionId;
};
